import React from 'react'

const MiniCartButtons = ({
  hasItems,
  onClose,
  GoToCartButton,
  GoToShopButton
}: {
  hasItems: boolean
  onClose: () => void
  GoToCartButton?: React.ReactElement
  GoToShopButton?: React.ReactElement
}) => (
  <div className='p-5 xl:flex xl:space-x-3' onClick={() => onClose()}>
    {GoToShopButton && GoToShopButton}
    {hasItems && GoToCartButton}
  </div>
)

export default MiniCartButtons
